import { createSlice } from "@reduxjs/toolkit";
import { adminLogin } from "./authThunk";
import { resetAdminSocket } from "../../Api/socket";

const initialState = {
  admin: null,
  loading: false,
  error: null,
  accessToken: localStorage.getItem("adminToken") || null,
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.admin = null;
      state.accessToken = null;
      localStorage.removeItem("adminToken");
      resetAdminSocket();
    },
  },

  extraReducers: (builder) => {
    builder.addCase(adminLogin.pending, (state) => {
      state.loading = true;
      state.error = null;
    });

    builder.addCase(adminLogin.fulfilled, (state, action) => {
      state.loading = false;
      state.admin = action.payload;

      // ✅ Postman response অনুযায়ী
      state.accessToken = action.payload?.accessToken || null;

      // ✅ TOKEN SAVE
      if (action.payload?.accessToken) {
        localStorage.setItem("adminToken", action.payload.accessToken);
        resetAdminSocket();
      }
    });

    builder.addCase(adminLogin.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;